module.exports = __webpack_public_path__ + "static/media/lungern-plazaA-01.d577a8da.webp";